let authToken: any = JSON.parse(localStorage.getItem('currentAdmin') || '{}');

export const Authorization = {
    'Content-Type' : 'application/json',
    'Accept' : 'application/json',
    'Authorization' : `Bearer ${authToken.data && authToken.data.token}`
}